export default "__VITE_ASSET__BI39iTJB__"